import { Separator } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import ArticleTiles from './ArticleTiles'
import OtherArticles from './OtherArticles'

const RelatedArticles = () => {
  const { relatedArticles, otherArticles } = useStaticData()

  if (!relatedArticles?.length && !otherArticles?.length) return null

  return (
    <section className='container mc-py-10' data-testid='related-articles'>
      <Separator className='mc-my-0' />
      <div className='row mc-mt-10'>
        <div className='col-12 col-md-8 col-lg-9'>
          <ArticleTiles articles={relatedArticles} />
        </div>
        {otherArticles?.length > 0 && (
          <OtherArticles articles={otherArticles} />
        )}
      </div>
    </section>
  )
}

export default RelatedArticles
